import React, { useState, useEffect } from 'react';
import './ConviteEvento.css';
import CalrizLogo from '../../assets/logos/logo-oficial-calriz.png';
import GoogleCloudLogo from '../../assets/logos/google-cloud.png';
import HeroImg from '../../assets/convite-evento/hero.png';
import GoogleCloudFooter from '../../assets/convite-evento/google-cloud-footer.png';
import IconBlog from '../../assets/convite-evento/icon-blog.png';
import IconGithub from '../../assets/convite-evento/icon-github.png';
import IconLinkedin from '../../assets/convite-evento/icon-linkedin.png';
import IconX from '../../assets/convite-evento/icon-x.png';
import IconFacebook from '../../assets/convite-evento/icon-facebook.png';
import Seo from '../../seo/Seo';

const EVENT_DATE = new Date('2026-06-10T08:00:00-03:00');

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function calcTimeLeft(): TimeLeft {
  const diff = EVENT_DATE.getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
  };
}

const agendaItems = [
  { time: '08h', title: 'Credenciamento + Coffee Networking' },
  { time: '9h30', title: 'Abertura' },
  { time: '10h', title: "Especialista Google: O Melhor do Next'26 para o setor público" },
  { time: '11h', title: 'Workspace e A.I' },
  { time: '11h30', title: 'Encerramento' },
  { time: '12h', title: 'Almoço executivo' },
];

export default function ConviteEvento() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calcTimeLeft);
  const [searchQuery, setSearchQuery] = useState('');


  useEffect(() => {
    const interval = setInterval(() => setTimeLeft(calcTimeLeft()), 1000);
    return () => clearInterval(interval);
  }, []);

  const filteredAgenda = agendaItems.filter(item =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  function handleStartRegistration(e?: React.MouseEvent) {
    if (e) e.preventDefault();
    // navegar para a página de inscrição dedicada
    window.location.href = '/best-of-next-goiania/inscricao';
  }

  return (
    <div className="rsvp-page">
      <Seo title="O melhor do Next – Goiânia" description="Impulsione a era agêntica com as novidades do Google Cloud 2026: evento presencial da Calriz em Goiânia." path="/best-of-next-goiania" noindex />

      <nav className="rsvp-nav">
        <div className="rsvp-nav-inner">
          <div className="rsvp-nav-left">
            <img src={CalrizLogo} alt="Calriz" className="rsvp-nav-calriz-logo" />
            <img src={GoogleCloudLogo} alt="Google Cloud" className="rsvp-nav-gc-logo" />
            <ul className="rsvp-nav-links">
              <li>
                <a href="#" className="rsvp-nav-link rsvp-nav-link--active">Home</a>
              </li>
            </ul>
          </div>

          <div className="rsvp-nav-right">
            <span className="rsvp-countdown">
              Começa em{' '}
              <strong>
                {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
              </strong>
            </span>
            <a href="#" onClick={handleStartRegistration} className="rsvp-btn-pill">
              Inscrever-se
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="rsvp-hero">
        <div className="rsvp-hero-inner">
          <div className="rsvp-hero-content">
            <h1 className="rsvp-hero-title">
              Impulsione a era agêntica com as novidades do Google Cloud 2026 para Goiânia
            </h1>
            <div className="rsvp-hero-meta">
              <div className="rsvp-hero-meta-item">
                <svg className="rsvp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <span className="rsvp-meta-blue">Data: 10/06</span>
              </div>
              <div className="rsvp-hero-meta-item">
                <svg className="rsvp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
                <span>Bairro Jardim Goiás - Goiânia</span>
              </div>
            </div>
            <a href="#" onClick={handleStartRegistration} className="rsvp-btn-pill">
              Inscrever-se
            </a>
          </div>
          <div className="rsvp-hero-image">
            <img src={HeroImg} alt="O melhor do Next" />
          </div>
          <a href="#" onClick={handleStartRegistration} className="rsvp-btn-pill rsvp-hero-cta">
            Inscrever-se
          </a>
        </div>
      </section>

      {/* Descrição */}
      <section className="rsvp-section rsvp-description">
        <div className="rsvp-section-inner">
          <p className="rsvp-description-lead">
            Descubra como as novas ferramentas do Google Cloud permitem a construção de uma força
            de trabalho digital que executa, aprende e otimiza seus negócios.
          </p>
          <p className="rsvp-description-body">
            Junte-se à <strong>Calriz</strong> e ao <strong>Google Cloud</strong> e descubra como as
            inovações do Next '26, lideradas pela nova era dos agentes de IA, podem transformar
            os desafios do seu negócio em oportunidades de crescimento exponencial.
          </p>

         

          <h3 className="rsvp-why-title">Por que participar?</h3>
          <p className="rsvp-why-subtitle">O evento será uma oportunidade de:</p>
          <ul className="rsvp-bullets">
            <li>
              Entender o que são agentes de IA e como eles podem automatizar processos complexos,
              interagir com sistemas e acelerar a tomada de decisão em seu negócio.
            </li>
            <li>
              Conhecer as estratégias e ferramentas de Data Cloud que preparam sua infraestrutura
              para garantir escalabilidade, governança e segurança.
            </li>
            <li>
              Conectar-se com especialistas para traduzir os lançamentos do Google Cloud Next '26
              em planos de ação relevantes para a sua empresa aplicados ao cenário de Goiânia.
            </li>
          </ul>
        </div>
      </section>

      {/* Inscrições agora em página dedicada: /best-of-next-goiania/inscricao */}

      {/* Agenda */}
      <section className="rsvp-section rsvp-agenda">
        <div className="rsvp-section-inner">
          <h2 className="rsvp-section-title">Agenda</h2>
          <div className="rsvp-agenda-header">
            <div></div>
            <div className="rsvp-agenda-tabs">
              <button className="rsvp-agenda-tab rsvp-agenda-tab--active">
                10/06
              </button>
            </div>
            
          </div>
          <div className="rsvp-agenda-list">
            {filteredAgenda.map((item, i) => (
              <div key={i} className="rsvp-agenda-item">
                <span className="rsvp-agenda-time">{item.time}</span>
                <span className="rsvp-agenda-title">{item.title}</span>
                <div className="rsvp-agenda-actions">
                  <button className="rsvp-agenda-action" title="Adicionar ao calendário">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <rect x="3" y="4" width="18" height="18" rx="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                  </button>
                  <button className="rsvp-agenda-action" title="Compartilhar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <circle cx="18" cy="5" r="3" />
                      <circle cx="6" cy="12" r="3" />
                      <circle cx="18" cy="19" r="3" />
                      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="rsvp-footer">
        <div className="rsvp-footer-inner">
          <img src={GoogleCloudFooter} alt="Google Cloud" className="rsvp-footer-logo" />
          <p className="rsvp-footer-copy">
            © 2026 Google LLC<br />
            1600 Amphitheatre Parkway, Mountain View, CA 94043
          </p>
          <div className="rsvp-social-links">
            <a href="https://cloud.google.com/blog/products/gcp" target="_blank" rel="noopener noreferrer">
              <img src={IconBlog} alt="Google Blog" />
            </a>
            <a href="https://github.com/GoogleCloudPlatform" target="_blank" rel="noopener noreferrer">
              <img src={IconGithub} alt="Github" />
            </a>
            <a href="https://www.linkedin.com/showcase/google-cloud" target="_blank" rel="noopener noreferrer">
              <img src={IconLinkedin} alt="LinkedIn" />
            </a>
            <a href="https://x.com/googlecloud" target="_blank" rel="noopener noreferrer">
              <img src={IconX} alt="X" />
            </a>
            <a href="https://www.facebook.com/googlecloud" target="_blank" rel="noopener noreferrer">
              <img src={IconFacebook} alt="Facebook" />
            </a>
          </div>
        </div>
      </footer>

    </div>
  );
}
